module.exports = __webpack_public_path__ + "static/media/grant-mobile.3c1eb440.svg";